import { useState } from "react";
import { IErrorResponse } from "@api";
import { useDataQuery } from "@Libs/DataLayer/hooks/useDataQuery";
import { ID } from "@types";
import {
  getServiceOffer,
  IServiceOffer,
  IGetServiceOfferOptions,
} from "../services/serviceOffers";

interface IUseContextOptions extends IGetServiceOfferOptions {
  onError?: (error: IErrorResponse) => void;
}

export const useServiceOffer = (
  serviceOfferId: ID | undefined,
  options?: IUseContextOptions
) => {
  const [apiError, setApiError] = useState<IErrorResponse>();
  const {
    data: serviceOffer,
    isLoading,
    isError,
    isSuccess,
    status,
    refetch,
  } = useDataQuery<IServiceOffer>(
    ["serviceOffer", Number(serviceOfferId), options],
    async () => {
      try {
        const response = await getServiceOffer(serviceOfferId, options);
        return response.data;
      } catch (error) {
        setApiError(error);
        throw error;
      }
    },
    {
      enabled: !!serviceOfferId,
    }
  );

  const totalExpenses = serviceOffer?.expenses?.reduce((acc, curr) => {
    return (acc += curr.amountCents);
  }, 0);

  const totalExpensesFees =
    serviceOffer?.expenses?.reduce((acc, curr) => {
      if (curr?.fees?.length > 0) return acc + curr?.fees?.[0]?.amountCents;
    }, 0) ?? 0;

  return {
    serviceOffer,
    isLoading,
    isError,
    isSuccess,
    refetch,
    status,
    apiError,
    totalExpenses,
    totalExpensesFees,
  };
};
